"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function createIncludeNamesTree(namesChain, includeTree) {
    var namesArray = namesChain.split('.');
    var currentIncludeName = namesArray.shift();
    var chainHasMoreNames = namesArray.length;
    var subTree = null;
    if (chainHasMoreNames) {
        subTree = includeTree[currentIncludeName] || {};
        createIncludeNamesTree(namesArray.join('.'), subTree);
    }
    includeTree[currentIncludeName] = subTree;
}
exports.createIncludeNamesTree = createIncludeNamesTree;
function jsonParse(stringified) {
    var parsed;
    try {
        parsed = JSON.parse(stringified);
    }
    catch (e) {
        parsed = {};
        console.warn(e);
    }
    return parsed;
}
exports.jsonParse = jsonParse;
//# sourceMappingURL=utils.js.map


//////////////////
// WEBPACK FOOTER
// ./~/jsona/lib/utils.js
// module id = 34
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 23 24 27 31 33 51 52 53 54 55 56 57 58 59 60 61 62 63 64 65 66 67 68 69 71 72 82 89 90 96 100 101 102 103 105 106 107 108 109 110 112 118 119 129 138 181 260 261